import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { Report, ReportParams, PaginatedResponse, ApiResponse } from '@com.maessa.payroll.frontend/models';

@Injectable({ providedIn: 'root' })
export class ReportApiService extends BaseApiService {
  createReport(params: ReportParams): Observable<ApiResponse<Report>> {
    return this.post<ApiResponse<Report>>(`${this.baseUrl}/reports`, params);
  }

  getReportStatus(id: number): Observable<ApiResponse<Report>> {
    return this.get<ApiResponse<Report>>(`${this.baseUrl}/reports/${id}/status`);
  }

  getReportHistory(filters?: { page?: number; per_page?: number }): Observable<PaginatedResponse<Report>> {
    const params = this.buildParams(filters ?? {});
    return this.get<PaginatedResponse<Report>>(`${this.baseUrl}/reports`, params);
  }

  downloadReport(id: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/reports/${id}/download`, {
      responseType: 'blob',
    });
  }
}
